export function submitEditCustomer()
{
    return({
        type:"EDIT_CUSTOMER_SUBMIT"
    })
}